import { employeeMessagesEN } from './lib/intl/en-US';

export const programId = '5ee238c1ea26521a9e0a9455';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com',
    },

    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': employeeMessagesEN,
    },
};
